import service from './service';
import router from '@/router/router';
import {
  removeToken,
  removeUser
} from './auth';
import {
  Message
} from 'element-ui';
import { SysConfigServiceSvr } from '@/service/SysConfigMge/SysConfigServiceSvr';
import { CommonControllerSvr } from '@/service/CommonControllerSvr/CommonControllerSvr';

function getSystemConfig(next){
  new CommonControllerSvr().GetSysSettingByString(' ','redirect2SSOURLLogOut').then(res=>{
    if(res==''){
      router.push(next);
    }else{
      window.location.href=res;
      return;
    }
  });
}

const request = {
  post: function (url, params) {
    return new Promise((resolve, reject) => {
      service
        .post(url, params)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          if (typeof err.Msg === 'string') {
            if (err.Msg.indexOf('无效的用户安全标识,或登录已过期') >= 0 || err.Msg.indexOf('用户未登陆') >= 0) {
              removeToken();
              removeUser()
              Message.error({
                message: '无效的用户安全标识,或登录已过期!'
              });
              // router.push('login');
              getSystemConfig('login');
            } else if (err.Msg.indexOf('timeout') >= 0) {
              reject();
              router.push('/500');
            } else {
              reject(err);
            }
          } else {
            reject(err);
          }
        });
    });
  }
};
export default request;